<div class="grid-option" *ngIf="gridOption$ | async as gridOption">
  <button (click)="selectGridOption('grid')" [class.active]="gridOption === 'grid'">
    <span *ngIf="gridOption === 'grid'" class="material-symbols-outlined check-icon">check</span>
    <span class="material-symbols-outlined">grid_view</span>
  </button>
  <button (click)="selectGridOption('list')" [class.active]="gridOption === 'list'">
    <span *ngIf="gridOption === 'list'" class="material-symbols-outlined check-icon">check</span>
    <span class="material-symbols-outlined">list</span>
  </button>
</div>
